import { mountStandaloneApp } from '@yuksalish/ui'
import CapacityPage from './pages/CapacityPage.vue'
import CalendarPage from './pages/CalendarPage.vue'
import MaterialsPage from './pages/MaterialsPage.vue'
import ProductionOrdersPage from './pages/ProductionOrdersPage.vue'
import ReschedulingPage from './pages/ReschedulingPage.vue'
import ScheduleBoardPage from './pages/ScheduleBoardPage.vue'
import ShiftPlanningPage from './pages/ShiftPlanningPage.vue'
import MachineLoadingPage from './pages/MachineLoadingPage.vue'
import BatchPlanningPage from './pages/BatchPlanningPage.vue'
import { planningMessages } from './i18n'
import './styles.css'

const productionOrdersView = 'production_orders.view'

mountStandaloneApp({
  code: 'planning',
  title: {
    en: planningMessages.en.planning.appTitle,
    ru: planningMessages.ru.planning.appTitle,
    uz: planningMessages.uz.planning.appTitle,
  },
  description: {
    en: planningMessages.en.planning.appDescription,
    ru: planningMessages.ru.planning.appDescription,
    uz: planningMessages.uz.planning.appDescription,
  },
  messages: planningMessages,
  accent: '#896318',
  requiredPermissions: ['production_orders.view'],
  navigation: [
    { label: { en: planningMessages.en.planning.nav.schedule, ru: planningMessages.ru.planning.nav.schedule, uz: planningMessages.uz.planning.nav.schedule }, to: '/' },
    { label: { en: planningMessages.en.planning.nav.calendar, ru: planningMessages.ru.planning.nav.calendar, uz: planningMessages.uz.planning.nav.calendar }, to: '/calendar' },
    { label: { en: planningMessages.en.planning.nav.capacity, ru: planningMessages.ru.planning.nav.capacity, uz: planningMessages.uz.planning.nav.capacity }, to: '/capacity' },
    {
      label: { en: planningMessages.en.planning.nav.orders, ru: planningMessages.ru.planning.nav.orders, uz: planningMessages.uz.planning.nav.orders },
      to: '/orders',
    },
    { label: { en: planningMessages.en.planning.nav.materials, ru: planningMessages.ru.planning.nav.materials, uz: planningMessages.uz.planning.nav.materials }, to: '/materials' },
    { label: { en: planningMessages.en.planning.nav.rescheduling, ru: planningMessages.ru.planning.nav.rescheduling, uz: planningMessages.uz.planning.nav.rescheduling }, to: '/rescheduling' },
    {
      label: { en: planningMessages.en.planning.nav.shifts, ru: planningMessages.ru.planning.nav.shifts, uz: planningMessages.uz.planning.nav.shifts },
      to: '/shifts',
      permission: productionOrdersView,
    },
    {
      label: { en: planningMessages.en.planning.nav.machineLoading, ru: planningMessages.ru.planning.nav.machineLoading, uz: planningMessages.uz.planning.nav.machineLoading },
      to: '/machine-loading',
      permission: productionOrdersView,
    },
    {
      label: { en: planningMessages.en.planning.nav.batches, ru: planningMessages.ru.planning.nav.batches, uz: planningMessages.uz.planning.nav.batches },
      to: '/batches',
      permission: productionOrdersView,
    },
  ],
  routes: [
    { path: '', component: ScheduleBoardPage },
    { path: 'calendar', component: CalendarPage },
    { path: 'capacity', component: CapacityPage },
    { path: 'orders', component: ProductionOrdersPage },
    { path: 'materials', component: MaterialsPage },
    { path: 'rescheduling', component: ReschedulingPage },
    { path: 'shifts', component: ShiftPlanningPage, meta: { permission: productionOrdersView } },
    { path: 'machine-loading', component: MachineLoadingPage, meta: { permission: productionOrdersView } },
    { path: 'batches', component: BatchPlanningPage, meta: { permission: productionOrdersView } },
  ],
})
